import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import GlobalContext from '../context/store';
import { Post } from '../api/server';

export default function Unsubscribe() {
  const { company = {} } = useContext(GlobalContext) || {};
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const [submittedEmail, setSubmittedEmail] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  async function handleSubmit(event) {
    event.preventDefault();
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setStatus('error');
      setMessage('Please enter the email address you want to unsubscribe.');
      return;
    }

    setStatus('loading');
    setMessage('');
    try {
      const response = await Post('/emailBlasts/unsubscribe', {
        email: trimmedEmail,
        company: company?._id,
      });
      if (response?.status === 404) {
        setStatus('error');
        setMessage('We could not find that email. Please check the spelling and try again.');
        return;
      }
      setSubmittedEmail(trimmedEmail);
      setStatus('success');
    } catch (error) {
      setStatus('error');
      setMessage('We could not find that email. Please check the spelling and try again.');
    }
  }

  if (status === 'success') {
    return (
      <section className="ticket-page">
        <div className="container ticket-form-page">
          <div className="ticket-page__intro">
            <p className="ticket-eyebrow">Email preferences</p>
            <h1 className="ticket-page__title">You&apos;re unsubscribed</h1>
            <p className="ticket-page__lead">{submittedEmail} will no longer receive Dollhouse Mermaid promotional emails.</p>
            <Link className="myButn" to="/">Return home</Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="ticket-page" aria-labelledby="unsubscribe-heading">
      <div className="container ticket-form-page">
        <div className="ticket-page__intro">
          <p className="ticket-eyebrow">Email preferences</p>
          <h1 id="unsubscribe-heading" className="ticket-page__title">Unsubscribe</h1>
          <p className="ticket-page__lead">Enter the email address that receives Dollhouse Mermaid updates, and we&apos;ll take it off the list.</p>
        </div>
        <div className="ticket-form-panel">
          <form onSubmit={handleSubmit} noValidate>
            <label className="ticket-field" htmlFor="unsubscribe-email"><span className="ticket-field__label">Email address</span>
              <input
                id="unsubscribe-email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
                required
              />
            </label>
            {message && <p className="ticket-error" role="alert">{message}</p>}
            <div className="ticket-form-actions">
              <button className="myButn" type="submit" disabled={status === 'loading'}>
                {status === 'loading' ? 'Unsubscribing...' : 'Unsubscribe'}
              </button>
              <Link to="/">Keep me subscribed</Link>
            </div>
          </form>
        </div>
        <p className="text-center mt-4">For privacy questions, see the <Link to="/privacy">Privacy Policy</Link>.</p>
      </div>
    </section>
  );
}
